import { normalSanatizerBRL } from "src/utils/functions";
import type { ResultsType } from "../calculadora-veiculo-eletrico_d";

export default function VeiculoEletricoTable({
  results,
}: {
  results: ResultsType;
}) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse bg-white rounded">
        <thead className="bg-gray-100 sticky top-0">
          <tr>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700 border-b-2">
              Mês
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700 border-b-2">
              Gasto Combustível
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700 border-b-2">
              Gasto Elétrico
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700 border-b-2">
              Economia Acumulada
            </th>
          </tr>
        </thead>
        <tbody>
          {results.monthlyData.map((data, index) => (
            <tr 
              className={`border-b hover:bg-gray-50 transition-colors ${
                index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
              }`} 
              key={data.month}
            >
              <td className="px-4 py-3 text-center text-sm font-medium text-gray-800">
                {data.month}º
              </td>
              <td className="px-4 py-3 text-center text-sm text-red-700">
                R$ {normalSanatizerBRL(data.fuelAccumulated)}
              </td>
              <td className="px-4 py-3 text-center text-sm text-green-700">
                R$ {normalSanatizerBRL(data.electricAccumulated)}
              </td>
              <td
                className={`px-4 py-3 text-center text-sm font-semibold ${
                  data.savingsAccumulated >= 0
                    ? "text-green-700"
                    : "text-red-700"
                }`}
              >
                {data.savingsAccumulated >= 0 ? "+" : ""}
                R$ {normalSanatizerBRL(Math.abs(data.savingsAccumulated))}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="bg-gray-100">
          <tr className="border-t-2">
            <td className="px-4 py-3 text-center text-sm font-bold text-gray-800">
              Total Anual
            </td>
            <td className="px-4 py-3 text-center text-sm font-bold text-red-800">
              R$ {normalSanatizerBRL(results.fuelAnnualCost)}
            </td>
            <td className="px-4 py-3 text-center text-sm font-bold text-green-700">
              R$ {normalSanatizerBRL(results.electricAnnualCost)}
            </td>
            <td className={`px-4 py-3 text-center text-sm font-bold ${
              results.annualSavings >= 0 ? "text-green-700" : "text-red-700"
            }`}>
              {results.annualSavings >= 0 ? "+" : ""}
              R$ {normalSanatizerBRL(Math.abs(results.annualSavings))}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}